var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"loading-fade"}},[(_vm.isLoading)?_c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"loading-overlay__spinner"},[_c('div',{staticClass:"loading-overlay__dot"}),_c('div',{staticClass:"loading-overlay__dot"}),_c('div',{staticClass:"loading-overlay__dot"})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }